var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpande(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2bcf6b47c3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 0 C 83.945312 0 0 83.945312 0 187.5 C 0 291.054688 83.945312 375 187.5 375 C 291.054688 375 375 291.054688 375 187.5 C 375 83.945312 291.054688 0 187.5 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cf1e2befa9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 208 70 L 305 70 L 305 167 L 208 167 Z M 208 70 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "433036f0b1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.503906 142.949219 L 281.371094 49.082031 L 325.917969 93.628906 L 232.050781 187.496094 Z M 187.503906 142.949219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2b0c7fa3d1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.503906 142.949219 L 281.371094 49.082031 L 325.917969 93.628906 L 232.050781 187.496094 Z M 187.503906 142.949219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cc839f0c04"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70 208 L 167 208 L 167 305 L 70 305 Z M 70 208 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d07f1512f1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.492188 232.039062 L 93.625 325.910156 L 49.074219 281.359375 L 142.945312 187.492188 Z M 187.492188 232.039062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6478f9e0ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.492188 232.039062 L 93.625 325.910156 L 49.074219 281.359375 L 142.945312 187.492188 Z M 187.492188 232.039062 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2bcf6b47c3)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 0.0000045, -0.000000000000063949)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 249.999994 0.000000000000085265 C 111.927078 0.000000000000085265 -0.000006 111.927084 -0.000006 250 C -0.000006 388.072917 111.927078 500.000001 249.999994 500.000001 C 388.072911 500.000001 499.999995 388.072917 499.999995 250 C 499.999995 111.927084 388.072911 0.000000000000085265 249.999994 0.000000000000085265 ",
    stroke: "#c7d300",
    strokeWidth: 8,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cf1e2befa9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#433036f0b1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2b0c7fa3d1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c7d300",
    d: "M 304.761719 112.128906 L 304.726562 75.011719 C 304.726562 72.4375 302.605469 70.316406 300.03125 70.3125 L 262.875 70.238281 C 260.300781 70.234375 258.183594 72.351562 258.1875 74.925781 C 258.1875 77.5 260.308594 79.617188 262.882812 79.621094 L 288.707031 79.644531 L 209.769531 158.582031 C 207.945312 160.40625 207.949219 163.394531 209.777344 165.222656 C 211.605469 167.050781 214.59375 167.054688 216.417969 165.230469 L 295.3125 86.335938 L 295.335938 112.160156 C 295.339844 113.488281 295.878906 114.609375 296.753906 115.484375 C 297.625 116.355469 298.789062 116.855469 300.074219 116.898438 C 302.648438 116.816406 304.765625 114.703125 304.761719 112.128906 Z M 304.761719 112.128906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc839f0c04)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d07f1512f1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6478f9e0ad)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c7d300",
    d: "M 70.230469 262.863281 L 70.265625 299.980469 C 70.269531 302.554688 72.386719 304.671875 74.960938 304.675781 L 112.121094 304.75 C 114.695312 304.753906 116.8125 302.640625 116.808594 300.066406 C 116.804688 297.492188 114.6875 295.371094 112.113281 295.367188 L 86.289062 295.34375 L 165.222656 216.410156 C 167.050781 214.582031 167.046875 211.59375 165.21875 209.765625 C 163.390625 207.9375 160.398438 207.933594 158.574219 209.761719 L 79.679688 288.652344 L 79.65625 262.828125 C 79.65625 261.5 79.113281 260.378906 78.242188 259.507812 C 77.367188 258.632812 76.207031 258.136719 74.917969 258.09375 C 72.34375 258.171875 70.230469 260.289062 70.230469 262.863281 Z M 70.230469 262.863281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpande);
export default __webpack_public_path__ + "static/media/expande.43e0e0bf9c0ff78eece3c7faca37391c.svg";
export { ForwardRef as ReactComponent };